var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "qaList" },
    [
      _c("div", { staticClass: "attentionBox" }, [
        _c("div", {}, [
          _c("div", { staticClass: "searchRight" }, [
            !_vm.edit
              ? _c(
                  "span",
                  { staticClass: "batch", on: { click: _vm.showEdit } },
                  [_vm._v("批量管理")]
                )
              : _c(
                  "div",
                  { staticClass: "saveList" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { "true-label": 1, "false-label": 0 },
                        on: { change: _vm.changeChecked },
                        model: {
                          value: _vm.selectAll,
                          callback: function($$v) {
                            _vm.selectAll = $$v
                          },
                          expression: "selectAll"
                        }
                      },
                      [_vm._v("全选")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "delete", on: { click: _vm.delFun } },
                      [_vm._v("删除")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "save", on: { click: _vm.saveList } },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "sub-main",
              attrs: { label: "我的提问", name: "question" }
            },
            [
              _vm.flag
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        { staticClass: "questionList listBox" },
                        _vm._l(_vm.questionList, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: item.problemId,
                              staticClass: "item",
                              class: {
                                selected: item.selected === 1,
                                edit: _vm.edit
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectQu(index, item.selected)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "questionBox" }, [
                                _vm.edit
                                  ? _c("div", { staticClass: "mc" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "cur-poi",
                                  attrs: { src: item.image, alt: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toProductDetail(item)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "infoBox" }, [
                                  _c("div", [
                                    _c("h3", [_vm._v(_vm._s(item.problem))]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "time" }, [
                                      _vm._v(_vm._s(item.createTime))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  item.answers.length
                                    ? _c(
                                        "ul",
                                        {
                                          class: {
                                            moreShow: _vm.current === index
                                          }
                                        },
                                        _vm._l(item.answers, function(
                                          anw,
                                          inx
                                        ) {
                                          return _c(
                                            "li",
                                            { key: anw.answerId },
                                            [
                                              _c("p", [
                                                _vm._v(_vm._s(anw.answer))
                                              ]),
                                              _vm._v(" "),
                                              item.answers.length > 1
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "viewDetail",
                                                      class: {
                                                        noSee:
                                                          _vm.current !==
                                                            null &&
                                                          inx !==
                                                            item.answers
                                                              .length -
                                                              1
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.seeAll(
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.current === null
                                                            ? "查看全部"
                                                            : "收起"
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : _c("p", { staticClass: "noReply" }, [
                                        _vm._v("暂无回答")
                                      ])
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.questionList.length
                        ? _c("el-pagination", {
                            staticClass: "mar-top-30",
                            attrs: {
                              background: "",
                              layout: "prev, pager, next, jumper",
                              "page-size": _vm.questionPageSize,
                              "current-page": _vm.questionPage,
                              total: _vm.questionTotal
                            },
                            on: { "current-change": _vm.questionChangePage }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "nothing sub-main" },
                    [
                      _c("img", {
                        staticClass: "cur-poi",
                        attrs: {
                          src: require("../../../../static/image/noorder@2x.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "fs20 font-color-999" }, [
                        _vm._v("您还没有提问～")
                      ]),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: "/" } },
                        [_c("el-button", [_vm._v("去首页看看")])],
                        1
                      )
                    ],
                    1
                  )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "sub-main",
              attrs: { label: "我的回答", name: "QA" }
            },
            [
              _vm.flag1
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        { staticClass: "qaBoxList listBox" },
                        _vm._l(_vm.qaList, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: item.problemId,
                              staticClass: "item",
                              class: {
                                selected: item.selected === 1,
                                edit: _vm.edit
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectQa(index, item.selected)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "qaBox" }, [
                                _vm.edit
                                  ? _c("div", { staticClass: "mc" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: { src: item.image, alt: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toProductDetail(item)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "infoBox" },
                                  [
                                    _c("h3", [_vm._v(_vm._s(item.problem))]),
                                    _vm._v(" "),
                                    _vm._l(item.answers, function(anw, inx) {
                                      return _c("div", { key: anw.answerId }, [
                                        inx === 0
                                          ? _c("p", { staticClass: "reply" }, [
                                              _vm._v(_vm._s(anw.answer))
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        inx === 0
                                          ? _c(
                                              "p",
                                              { staticClass: "replyTime" },
                                              [
                                                _vm._v(
                                                  "回答于：" +
                                                    _vm._s(anw.createTime)
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "rightBox" }, [
                                _c("span", { staticClass: "time" }, [
                                  _vm._v(_vm._s(item.createTime))
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.qaList.length
                        ? _c("el-pagination", {
                            staticClass: "mar-top-30",
                            attrs: {
                              background: "",
                              layout: "prev, pager, next, jumper",
                              "page-size": _vm.qaPageSize,
                              "current-page": _vm.qaPage,
                              total: _vm.qaTotal
                            },
                            on: { "current-change": _vm.qaChangePage }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "nothing sub-main" },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../../../static/image/noorder@2x.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "fs20 font-color-999" }, [
                        _vm._v("您还没有回答～")
                      ]),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: "/" } },
                        [_c("el-button", [_vm._v("去首页看看")])],
                        1
                      )
                    ],
                    1
                  )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-9763b734", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-9763b734","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/messageCenter/qalist.vue
// module id = null
// module chunks = 